<section id="form">
    <form
      [formGroup]="formulario"
      class="form container bg-color-light-grey color-dark"
      (ngSubmit)="onSubimitFormulario()"
    >
    <h2 class="form-title text-center">Proposta de inclusão de curso experimental</h2>
    <div class="form-group">
        <label class="form-label">
          Nome da instituição*:
         <input type="text" class="input" formControlName="nomeInstituicao">
        </label>
    </div>
  
    <div class="form-group">
        <label class="form-label">
          Endereço do local da oferta*:
          <input type="text" class="input" formControlName="enderecoLocalOferta">
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
          Site da instituição*:
          <input type="text" class="input" formControlName="site">
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
          Nome do(a) responsável pelo preenchimento*:
          <input type="text" class="input" formControlName="reponsavelPreenchimentoNome">
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
          E-mail para contato*:
          <input type="text" class="input" formControlName="reponsavelPreenchimentoEmail">
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
          Título do curso*:
          <input type="text" class="input" formControlName="tituloCurso">
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
          Código E-MEC ou do respectivo sistema ofertante:
          <input type="text" class="input" formControlName="codigoSistemaOfertante">
        </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        Caso o código informado não seja E-MEC, informe o nome do sistema ofertante:
        <input type="text" class="input" formControlName="nomeSistemaOfertante">
      </label>
  </div>

    <div class="form-group">
        <label class="form-label">
          Código Cine*:
          <input type="text" class="input" maxlength="7" formControlName="codCine">
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
          Eixo tecnológico*:
          <select formControlName="eixoTecnologicoCncstId" class="form-control select" id="eixo">
            <option [ngValue]="null" disabled selected>Selecione o Eixo tecnológico</option>
            <option *ngFor="let eixo of eixos" [ngValue]="eixo.id">{{ eixo.nome }}</option>
          </select>
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
          O título já está na tabela de convergência do CNCST?*:
        </label>
        <div class="radio-box">
            <label class="radio-input">
                <input type="radio" name="tituloEstaTabelaConvergencia" [value]="true" formControlName="tituloEstaTabelaConvergencia">
                Sim
            </label>
            <label class="radio-input">
                <input type="radio" name="tituloEstaTabelaConvergencia" [value]="false" formControlName="tituloEstaTabelaConvergencia">
                Não
            </label>
        </div>
        <span class="warning">*cursos na tabela de convergência não podem ser ofertados como experimentais</span>
    </div>

    <div class="form-group">
        <label class="form-label">
          Justificativa para a oferta deste curso*:
          <textarea class="textarea" formControlName="justificativaOfertaCurso"></textarea>
          <span [ngClass]="{'red': formulario.get('justificativaOfertaCurso').invalid && formulario.get('justificativaOfertaCurso').touched}">
            {{formulario.get('justificativaOfertaCurso').value.length}}/5000</span>
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
          Qual a carga horária deste curso*:
          <textarea class="textarea" formControlName="cargaHoraria"></textarea>
          <span [ngClass]="{'red': formulario.get('cargaHoraria').invalid && formulario.get('cargaHoraria').touched}">
            {{formulario.get('cargaHoraria').value.length}}/5000</span>
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
          Há algum pré-requisito para ingresso além da aprovação em processo seletivo?*:
        </label>
        <div class="radio-box">
            <label for="sim" class="radio-input">
                <input type="radio" name="haPreRequisito" value="sim" formControlName="haPreRequisito">
                Sim
            </label>
            <label for="sim" class="radio-input">
                <input type="radio" name="haPreRequisito" value="nao" formControlName="haPreRequisito">
                Não
            </label>
        </div>
    </div>

    <div class="form-group" *ngIf="formulario.get('haPreRequisito').value === 'sim'">
        <label class="form-label">
          Qual(is)*:
          <textarea class="textarea" formControlName="preRequisitoIngresso"></textarea>
          <span [ngClass]="{'red': formulario.get('preRequisitoIngresso').invalid && formulario.get('preRequisitoIngresso').touched}">
            {{formulario.get('preRequisitoIngresso').value.length}}/5000</span>
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
            Descreva o perfil profissional de conclusão tal qual está no PPC autorizado*:
          <textarea class="textarea" formControlName="perfilProfissional"></textarea>
          <span [ngClass]="{'red': formulario.get('perfilProfissional').invalid && formulario.get('perfilProfissional').touched}">
            {{formulario.get('perfilProfissional').value.length}}/5000</span>
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
            O curso é verticalização de algum curso técnico?*:
        </label>
        <div class="radio-box" >
            <label for="sim" class="radio-input">
                <input type="radio" name="eVerticalizacaoCurso" value="sim" formControlName="eVerticalizacaoCurso">
                Sim
            </label>
            <label for="sim" class="radio-input">
                <input type="radio" name="eVerticalizacaoCurso" value="nao" formControlName="eVerticalizacaoCurso">
                Não
            </label>
        </div>
    </div>

    <div class="form-group" *ngIf="formulario.get('eVerticalizacaoCurso').value === 'sim'">
        <label class="form-label">
            Qual(is)*:
          <textarea class="textarea" formControlName="verticalizadoCursoTecnico"></textarea>
          <span [ngClass]="{'red': formulario.get('verticalizadoCursoTecnico').invalid && formulario.get('verticalizadoCursoTecnico').touched}">
            {{formulario.get('verticalizadoCursoTecnico').value.length}}/5000</span>
        </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        O curso possui saídas intermediárias?*:
      </label>
      <div class="radio-box">
          <label for="sim" class="radio-input">
              <input type="radio" name="haSaidasIntermediarias" value="sim" formControlName="haSaidasIntermediarias">
              Sim
          </label>
          <label for="sim" class="radio-input">
              <input type="radio" name="haSaidasIntermediarias" value="nao" formControlName="haSaidasIntermediarias">
              Não
          </label>
      </div>
  </div>

  <div class="form-group" *ngIf="formulario.get('haSaidasIntermediarias').value === 'sim'">
    <label class="form-label">
        Qual(is)? (incluir os respectivos títulos e códigos CBO)*:
      <textarea class="textarea" formControlName="saidasIntermediariasPropostas"></textarea>
      <span [ngClass]="{'red': formulario.get('saidasIntermediariasPropostas').invalid && formulario.get('saidasIntermediariasPropostas').touched}">
        {{formulario.get('saidasIntermediariasPropostas').value.length}}/5000</span>
    </label>
</div>

    <div class="form-group">
        <label class="form-label">
            Qual o campo de atuação deste profissional?*:
          <textarea class="textarea" formControlName="campoAtuacaoProfissional"></textarea>
          <span [ngClass]="{'red': formulario.get('campoAtuacaoProfissional').invalid && formulario.get('campoAtuacaoProfissional').touched}">
            {{formulario.get('campoAtuacaoProfissional').value.length}}/5000</span>
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
            Existe alguma legislação profissional que possa ser associada?*:
        </label>
        <div class="radio-box">
            <label for="sim" class="radio-input">
                <input type="radio" name="existeLegislacao" value="sim" formControlName="existeLegislacao">
                Sim
            </label>
            <label for="sim" class="radio-input">
                <input type="radio" name="existeLegislacao" value="nao" formControlName="existeLegislacao">
                Não
            </label>
        </div>
    </div>

    <div class="form-group" *ngIf="formulario.get('existeLegislacao').value === 'sim'">
        <label class="form-label">
            Qual(is)*:
          <textarea class="textarea" formControlName="legislacaoAssociada"></textarea>
          <span [ngClass]="{'red': formulario.get('legislacaoAssociada').invalid && formulario.get('legislacaoAssociada').touched}">
            {{formulario.get('legislacaoAssociada').value.length}}/5000</span>
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
            Liste as ocupações associadas / relacionadas na CBO (título e código)*:
          <textarea class="textarea" formControlName="ocupacoesCbo"></textarea>
          <span [ngClass]="{'red': formulario.get('ocupacoesCbo').invalid && formulario.get('ocupacoesCbo').touched}">
            {{formulario.get('ocupacoesCbo').value.length}}/5000</span>
        </label>
    </div>

    <div class="form-group">
        <label class="form-label">
            Qual a infraestrutura mínima requerida para o funcionamento do curso?*:
          <textarea class="textarea" formControlName="infraestruturaMinima"></textarea>
          <span [ngClass]="{'red': formulario.get('infraestruturaMinima').invalid && formulario.get('infraestruturaMinima').touched}">
            {{formulario.get('infraestruturaMinima').value.length}}/5000</span>
        </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        Anexe o ato autorizativo e PPC do curso (em um único arquivo PDF)*:
      </label>
      <label for="file-upload" class="label-file">
        <img src="assets/common/upload-icon.svg" alt="">
        Escolher arquivo
        <span>{{fileName? fileName: null}}</span>
      </label>
      <input
        id="file-upload"
        type="file"
        accept="application/pdf"
        class="input-file"
        formControlName="file"
        (change)="fileChange($event)"
        
      >
      <span
      class="red"
      *ngIf="formulario.get('file').touched && formulario.get('file').invalid"
      >
      O envio do arquivo é obrigatório
    </span>
      <span class="red" *ngIf="fileError">{{fileError}}</span>
  </div>

  <div class="form-group">
    <label class="form-label">
      Número de vagas autorizadas (por ano)*:
      <input type="number" class="input input-number" formControlName="numeroVagasAutorizadasPorAno">
    </label>
  </div>

  <div class="form-group">
    <label class="form-label">
      Matrículas efetivas publicadas no Censo da Educação Superior do INEP*:
    </label>
    <div class="anos-form">
      <label class="form-label">
        2015
        <input type="number" class="input input-number" formControlName="matriculasPublicadasCenso2015">
      </label>
      <label class="form-label">
        2016
        <input type="number" class="input input-number" formControlName="matriculasPublicadasCenso2016">
      </label>
      <label class="form-label">
        2017
        <input type="number" class="input input-number" formControlName="matriculasPublicadasCenso2017">
      </label>
      <label class="form-label">
        2018
        <input type="number" class="input input-number" formControlName="matriculasPublicadasCenso2018">
      </label>
      <label class="form-label">
        2019
        <input type="number" class="input input-number" formControlName="matriculasPublicadasCenso2019">
      </label>
    </div>
  </div>

    <div class="form-checkbox form-group">
      <input type="checkbox" id="termo" class="input-checkbox" formControlName="aceitaTermo" />
      <label class="label-checkbox" for="termo"> {{textoTermo}} </label>
    </div>

    <div class="recaptcha">
      <re-captcha
        formControlName="reCaptcha"
        siteKey="6LfndeMcAAAAAPSpZjo6cC9PLyKLBKbZ2FJSyuIM"
      ></re-captcha>
    </div>

    <div class="wrapper">
      <button
        class="btn btn-md rounded-pill btn-dark cursor-pointer"
        id="botao-form"
        role="button"
        type="submit"
      >
        Enviar
      </button>
    </div>

    <app-popup
    [tipoFormulario]="'experimental'"
    [resposta]="resposta"
    [mostrarPopUp]="mostarPopUp"
    (cancel)="cancelar()"
    (submit)="onSubimitFormulario()"
    [erro]="erro"
  ></app-popup>

  </form>

</section>